import script from "./TransactionSuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionSuccessView.vue?vue&type=script&setup=true&lang=js"

import "./TransactionSuccessView.vue?vue&type=style&index=0&id=61776ae5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61776ae5"]])

export default __exports__